<script setup lang="ts">
import { computed } from "vue";
import { _battle } from "../ui/battle";
import { surrenderOperation } from "../core/operation";
import { Side } from "../core/round";
import SkipButton from "./SkipButton.vue";

const battle = _battle;
const props = defineProps<{ side: Side }>();

const skipDisabled = computed(
    () =>
        battle.phase !== "selecting" ||
        battle.viewMode !== "live" ||
        (battle.needsReplacement(props.side) &&
            !battle.getReplacement(props.side))
);

const surrenderDisabled = computed(
    () => battle.phase !== "selecting" || battle.viewMode !== "live"
);

function surrender() {
    const sideText = props.side === "left" ? "挑战方" : "被挑战方";
    if (!confirm(`${sideText}确定要认输吗？`)) return;
    battle.selectOperation(props.side, surrenderOperation);
}
</script>

<template>
    <div class="choice-group">
        <SkipButton :side="side" :force-disabled="skipDisabled" />
        <button
            class="choice-btn surrender-btn"
            :disabled="surrenderDisabled"
            title="认输"
            @click="surrender"
        >
            <img src="/assets/flag.svg" alt="" />
            <span>认输</span>
        </button>
    </div>
</template>

<style scoped>
.choice-group {
    display: inline-flex;
    gap: calc(var(--ui-unit) * 8);
}

.choice-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: calc(var(--ui-unit) * 5);
    width: calc(var(--ui-unit) * 72);
    height: calc(var(--ui-unit) * 58);
    padding: calc(var(--ui-unit) * 5);
    color: #e0e0e0;
    background: rgba(30, 30, 45, 0.9);
    border: calc(var(--ui-unit) * 1) solid rgba(255, 255, 255, 0.08);
    border-radius: calc(var(--ui-unit) * 8);
    cursor: pointer;
    transition: all 0.2s ease;
}

.choice-btn img {
    width: calc(var(--ui-unit) * 24);
    height: calc(var(--ui-unit) * 24);
    filter: brightness(0) invert(1);
    pointer-events: none;
}

.choice-btn span {
    font-size: calc(var(--ui-unit) * 12);
    font-weight: 600;
}

.surrender-btn:hover:not(:disabled) {
    color: #ef4444;
    border-color: rgba(239, 68, 68, 0.5);
    background: rgba(239, 68, 68, 0.1);
}

.choice-btn:disabled {
    cursor: not-allowed;
    opacity: 0.3;
}
</style>
